import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./Courses.css";
import { Alert, Button, Container, Table } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faExclamationCircle,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import BaseUrl from "../../base-api";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { submitPaymentForm } from "../../Utils/Commons";
import logo from "./../../assets/logo.jpg";
import hkcl from "../../assets/hkcl.png";
import jsPDF from "jspdf";
import 'jspdf-autotable';
import imageCompression from 'browser-image-compression';
import moment from "moment";
const Courses = () => {
  const [date, setDate] = useState(null);
  const [courses, setCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [payment, setPayment] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState('');
  const [photo, setPhoto] = useState(null);
  const [sign, setSign] = useState(null);
  useEffect(() => {
    axios
      .get(`${BaseUrl}/app/fetchEnrolledCourses`, {
        headers: {
          Authorization: localStorage.getItem("$3ingT0k3n"),
        },
      })
      .then(function (response) {
        setCourses(response.data);
        response.data[0].documentsDto.map(async (data, index) => {
          if (data.data) {
            const base64Image = 'data:image/jpeg;base64,' + data.data;
            const compressedImageBase64 = await compressImage(base64Image);
            switch (data.abbr) {
              case "photo":
                setPhoto(compressedImageBase64);
                break;
              case "sign":
                setSign(compressedImageBase64);
                break;
              default:
                break;
            }
          }
        });
        const datetimeStamp = response.data[0].enrolledOn;
        const dateOnly = extractDate(datetimeStamp);
        setDate(dateOnly);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);
  const payRegFee = async () => {
    try {

      const response = await axios.post(
        `${BaseUrl}/payRegFee`, {},
        {
          headers: {
            Authorization: localStorage.getItem("$3ingT0k3n"),
          },
        }
      );
      if (response.status == 200) {
        console.log(response);
        toast.success(response.data.message, {
          className: "toast-large",
          position: "top-center",
        }); setLoadingMessage("Waiting for payment confirmation....");
        setPayment(true);
        submitPaymentForm(response.data);
      } else toast.error(response.data.message, { position: "top-center" });
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message, { position: "top-center" });
    }
  };
  const payCourseFee = async () => {
    try {

      const response = await axios.post(
        `${BaseUrl}/payCourseFee`, {},
        {
          headers: {
            Authorization: localStorage.getItem("$3ingT0k3n"),
          },
        }
      );
      if (response.status == 200) {
        console.log(response);
        toast.success(response.data.message, {
          className: "toast-large",
          position: "top-center",
        }); setLoadingMessage("Waiting for payment confirmation....");
        setPayment(true);
        submitPaymentForm(response.data);
      } else toast.error(response.data.message, { position: "top-center" });
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message, { position: "top-center" });
    }
  };

  const compressImage = async (base64Image) => {
    const response = await fetch(base64Image);
    const blob = await response.blob();
    const options = {
      maxSizeMB: 2,
      maxWidthOrHeight: 1200,
      useWebWorker: true,
    };
    try {
      const compressedBlob = await imageCompression(blob, options);
      const compressedBase64 = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(compressedBlob);
        reader.onloadend = () => resolve(reader.result);
      });

      return compressedBase64;
    } catch (error) {
      console.error("Error during image compression", error);
      return base64Image;
    }
  };

  const downloadDetails = async (course) => {
    try {
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      const currentTime = new Date().toLocaleString();

      const websiteName = "Guru Jambheshwar University of Science & Technology, Hisar";
      // const websiteNameWork = "Admission Form";
      const websitelogName = "and";
      const websiteHkcl = "Haryana Knowledge Corporation Limited (HKCL)"
      const websiteNameWork = "Registration Form";

      const imageWidth = 20;
      const imageHeight = 20;
      const imageX = 10;

      doc.setFont("helvetica");

      const addHeader = () => {
        doc.setFontSize(8).setTextColor("black");
        const generatedTextWidth = doc.getTextWidth(`Generated on: ${currentTime}`);
        const generatedX = pageWidth - generatedTextWidth - 10;
        doc.text(`Generated on: ${currentTime}`, generatedX, 10);
        doc.text("https://gjuskillcourses.hkcl.in", 10, 10);

      };

      doc.setFontSize(16).setFont("helvetica", "bold");
      addHeader();
      doc.addImage(logo, 'JPEG', imageX, 12, imageWidth, imageHeight);

      doc.setFontSize(12).setTextColor("green");

      doc.text(websiteName, imageX + imageWidth + 12, 20);
      doc.text(websitelogName, imageX + imageWidth + 70, 25);
      doc.text(websiteHkcl, imageX + imageWidth + 30, 30);

      const websiteNameWorkWidth = doc.getTextWidth(websiteNameWork);
      const centerX = (pageWidth - websiteNameWorkWidth) / 2;
      const textY = 37;


      doc.text(websiteNameWork, centerX - 4, textY);


      const textHeight = 1.5;
      doc.line(centerX - 4, textY + textHeight, centerX - 3 + websiteNameWorkWidth, textY + textHeight);
      doc.addImage(hkcl, 'JPEG', pageWidth - imageX - imageWidth - 5, 14, imageWidth + 5, imageHeight);

      doc.setFontSize(12).setTextColor("black");

      doc.setFontSize(12).setTextColor("green");


      doc.text("Personal Details", 15, 50);

      doc.autoTable({
        startY: 55,
        columnStyles: {
          0: { cellWidth: 40 },
          1: { cellWidth: 100 },
        },
        body: [
          [
            { content: "Candidate Name", styles: { fontStyle: "bold" } },
            course.candidateName,
          ],
          [
            { content: "Father Name", styles: { fontStyle: "bold" } },
            course.fatherName,
          ],
          [
            { content: "Mobile Number", styles: { fontStyle: "bold" } },
            course.mobileNumber,
          ],
          [
            { content: "Email", styles: { fontStyle: "bold" } },
            course.email,
          ],
          [
            { content: "Date of Birth", styles: { fontStyle: "bold" } },
            moment(course.dob).format("DD/MM/YYYY"),
          ],
          [
            { content: "Full Address", styles: { fontStyle: "bold" } },
            `${course.address}, ${course.district}, ${course.state}, ${course.country}, ${course.pincode}`,
          ],
        ],
        theme: "grid",
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
        },
        didDrawPage: (data) => {

          if (data.pageNumber > 1) {
            addHeader();
          }


          const x = 160;
          const y = 55;
          doc.addImage(photo, "JPEG", x, y, 37, 38);
        },
      });



      doc.setFontSize(12).setTextColor("green");
      doc.text("Course Details", 15, doc.autoTable.previous.finalY + 10);
      doc.setFontSize(16);
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 15,
        body: [
          [{ content: "Enrolled Course", styles: { fontStyle: 'bold' } }, course.course], // Only course.course is kept
        ],
        theme: 'grid',
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
        },
        didDrawPage: (data) => {
          if (data.pageNumber > 1) {
            addHeader();
          }
        },
      })


      doc.setFontSize(12).setTextColor("green");
      doc.text("Details of 12th Standard or Equivalent", 15, doc.autoTable.previous.finalY + 10);
      doc.setFontSize(16);
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 15,
        body: [[{ content: "Roll Number", styles: { fontStyle: 'bold' } }, course.rollNumber],
        [{ content: "Board", styles: { fontStyle: 'bold' } }, course.board],
        [{ content: "Passing Month-Year", styles: { fontStyle: 'bold' } }, course.schoolMonth + "-" + course.schoolYear],
        [{ content: "Marks Obtained", styles: { fontStyle: 'bold' } }, course.marksObtained + " out of " + course.totalMarks],
        ],
        theme: 'grid',
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0]
        },
        didDrawPage: (data) => {
          if (data.pageNumber > 1) {
            addHeader();
          }
        }
      });


      doc.text("Submitted Documents", 15, doc.autoTable.previous.finalY + 10);
      doc.autoTable({
        startY: doc.autoTable.previous.finalY + 15,
        head: [['Sr. No.', 'Name']],
        body: course.documentsDto.map((item, index) => [index + 1, item.docName]),
        theme: 'grid',
        styles: {
          lineWidth: 0.1,
          lineColor: [0, 0, 0],
          halign: 'center'
        },
        columnStyles: {
          0: { cellWidth: 40 }
        },
        didDrawPage: (data) => {
          // Add header on new pages
          if (data.pageNumber > 1) {
            addHeader();
          }
        }
      });
      const paragraphText = "I declare that the information provided by me in the application form is true and correct to the best of my knowledge, and I have not concealed any facts. I also confirm that I have carefully read all the guidelines and instructions provided on the admission portal before submitting my application. I also acknowledge the importance of providing correct contact details, as all course-related updates will be sent to my registered mobile number and email ID. I am fully aware that the course once selected cannot be changed under any circumstances and that the course fee, once paid, is non-refundable and non-transferable. I also give my consent to receive updates and course-related information on my registered mobile number/WhatsApp and email ID.";


      const textStartY = doc.autoTable.previous.finalY + 10;
      const signatureStartY = textStartY + 30;


      doc.setFontSize(9);


      const lines = doc.splitTextToSize(paragraphText, 180);



      doc.text(lines, 15, textStartY, { maxWidth: 180, align: 'justify' });


      doc.setFontSize(8).setFont("helvetica", "underline").setTextColor("black");




      const marginBottom = 10;

      const signatureTextHeight = 10;

      const signatureImageHeight = 10;

      const signatureTextY = doc.internal.pageSize.height - marginBottom;
      const signatureImageY = signatureTextY - signatureImageHeight - 5;

      doc.addImage(sign, 'JPEG', pageWidth - 50, signatureImageY, 35, signatureImageHeight);


      doc.text("(Applicant Signature)", pageWidth - 40, signatureTextY);


      doc.save('Admission Form.pdf');

    } catch (error) {
      console.error('Failed to generate PDF:', error);
      alert('Failed to generate PDF. Please try again.');
    }
  };
  function extractDate(datetimeStamp) {
    const date = new Date(datetimeStamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  return (
    <div>
      <Container
        className="py-3 border round mt-3"
        style={{
          width: "97%",
          backgroundColor: "#f6f5f591",
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
          borderRadius: "9px",
        }}
      >


        <div style={{ textAlign: 'justify', fontSize: '0.9rem' }}>

          <h4 className='text-center' style={{ color: '#123fae' }}>GENERAL INSTRUCTIONS</h4>
          <ol>
            <li> Dear Candidate, once you have enrolled in a course, it will appear in the table below.</li>
            <li> Pay the registration fee of ₹101 by clicking the 'Pay Registration Fee' button.</li>
            <li> After successfully paying the registration fee, please wait for 3-4 working days for the university to approve your uploaded documents.</li>
            <li> Once your documents are approved, proceed to pay the full course fee.</li>
            <li> If your uploaded documents are rejected, please re-upload the required documents for review.</li>
          </ol>
        </div>
        <hr></hr>
        <div className="text-center">
          <h1
            style={{
              backgroundColor: "#4545ee9e",
              color: "white",
              borderRadius: "3px",
            }}
          >
            {" "}
            Enrolled Courses
          </h1>

          <Table striped className="mt-3">
            <thead>
              <tr className="table-warning">
                <th width="25%"> Course Name </th>
                <th width="15%"> Enrolled Date </th>
                <th width="20%"> Approval Status </th>
                <th width="25">Remarks </th>
                <th width="15%"> Fee Status </th>
                {courses.some(c => c.feeStatus) && <th width="15%"> Actions </th>}
              </tr>
            </thead>

            <tbody>
              {courses.map((c) => (
                <tr>
                  <td> {c.course} </td>
                  <td> {date} </td>
                  <td>
                    {(c.applicationStatus === "REGISTERED") ? (

                      <Button className="btn-sm btn-success" onClick={payRegFee}>Pay Registration Fee</Button>
                    ) : (
                      <FontAwesomeIcon
                        icon={
                          c.applicationStatus == "Approved"
                            ? faCheckCircle
                            : faExclamationCircle
                        }
                        style={{ color: c.applicationStatus == "Approved" ? "green" : "red" }}
                      ></FontAwesomeIcon>
                    )}
                  </td>

                  <td> {c.remarks} </td>

                  <td>
                    {c.applicationStatus === "Approved" && !c.feeStatus ? (
                      <button className="btn-sm btn-primary" onClick={payCourseFee}>Pay Fee</button>
                    ) : (
                      <FontAwesomeIcon
                        icon={c.feeStatus ? faCheckCircle : faExclamationCircle}
                        style={{ color: c.feeStatus ? "green" : "red" }}
                      ></FontAwesomeIcon>
                    )}

                  </td>
                  {c.feeStatus && (
                    <td>
                      <a style={{ color: "blue" }} href="" onClick={(e) => { e.preventDefault(); downloadDetails(c); }}>Print</a>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </Container>
    </div>
  );
};

Courses.propTypes = {};

Courses.defaultProps = {};

export default Courses;
